export const MOVE_POSITION_DIALOG_ID = 'move-position-dialog'
